import React from 'react';
import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { H4, NamedLink } from '../../components';
import css from './ProfilePage.module.css';

const SectionConsumerProfile = props => {
  const { publicData, metadata, listings } = props;
  const { preferences, location: consumerLocation } = publicData || {};

  const hasConsumerInfo = preferences || consumerLocation || (listings && listings.length > 0);

  if (!hasConsumerInfo) {
    return null;
  }

  return (
    <div className={css.consumerProfileSection}>
      <H4 as="h2" className={css.sectionTitle}>
        <FormattedMessage id="ProfilePage.consumerProfile.title" />
      </H4>
      
      <div className={css.consumerInfo}>
        {consumerLocation ? (
          <div className={css.infoRow}>
            <span className={css.infoLabel}>
              <FormattedMessage id="ProfilePage.consumerProfile.location" />:
            </span>
            <span className={css.infoValue}>{consumerLocation?.address || consumerLocation}</span>
          </div>
        ) : null}

        {preferences ? (
          <div className={css.infoRow}>
            <span className={css.infoLabel}>
              <FormattedMessage id="ProfilePage.consumerProfile.preferences" />:
            </span>
            <span className={css.infoValue}>{preferences}</span>
          </div>
        ) : null}

        {listings && listings.length > 0 ? (
          <div className={css.purchaseHistory}>
            <span className={css.infoLabel}>
              <FormattedMessage id="ProfilePage.consumerProfile.purchaseHistory" />:
            </span>
            <div className={css.recentPurchases}>
              <FormattedMessage 
                id="ProfilePage.consumerProfile.recentPurchases" 
                values={{ count: listings.length }} 
              />
            </div>
          </div>
        ) : null}
      </div>

      <div className={css.consumerActions}>
        <NamedLink className={css.actionButton} name="SearchPage" to={{ search:"address=Espa%C3%B1a&bounds=28.08136788%2C-15.4942265%2C27.93951364%2C-15.62583784&mapSearch=true" }}>
          <FormattedMessage id="ProfilePage.consumerProfile.browseProducts" />
        </NamedLink>
      </div>
    </div>
  );
};

export default SectionConsumerProfile;
